export var ApplePayShippingContactEditingModeObj = ["enabled", "storePickup"];
/** @internal */
export var validateApplePayShippingContactEditingMode = function (applePayShippingContactEditingMode) { return ApplePayShippingContactEditingModeObj.includes(applePayShippingContactEditingMode); };
